function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 5,
  fill: "#3FE2C5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.18221 13.8141C6.68173 11.1408 9.4579 10.8304 10.5516 10.943C10.6642 12.0367 10.3538 14.8129 7.68057 17.3124C5.00735 19.8119 2.31642 20.2398 1.37146 20.1232C1.25485 19.1782 1.68269 16.4873 4.18221 13.8141Z",
  fill: "#1DA48B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3743 4.62363C15.8739 1.9504 18.65 1.63997 19.7438 1.75257C19.8564 2.84631 19.5459 5.62248 16.8727 8.12199C14.1995 10.6215 11.5086 11.0494 10.5636 10.9327C10.447 9.98778 10.8748 7.29686 13.3743 4.62363Z",
  fill: "#1DA48B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5667 32.2042C25.0662 29.531 27.8424 29.2205 28.9362 29.3331C29.0488 30.4269 28.7383 33.203 26.0651 35.7026C23.3919 38.2021 20.7009 38.6299 19.756 38.5133C19.6394 37.5683 20.0672 34.8774 22.5667 32.2042Z",
  fill: "#1DA48B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7591 23.0091C34.2586 20.3359 37.0348 20.0255 38.1285 20.1381C38.2411 21.2318 37.9307 24.008 35.2575 26.5075C32.5843 29.007 29.8933 29.4349 28.9484 29.3182C28.8318 28.3733 29.2596 25.6824 31.7591 23.0091Z",
  fill: "#1DA48B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4344 35.6973C10.7612 33.1978 10.4508 30.4216 10.5634 29.3279C11.6571 29.2153 14.4333 29.5257 16.9328 32.1989C19.4323 34.8722 19.8601 37.5631 19.7435 38.5081C18.7986 38.6247 16.1076 38.1968 13.4344 35.6973Z",
  fill: "#28BCA1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.24277 26.507C1.56954 24.0075 1.25912 21.2313 1.37171 20.1376C2.46545 20.025 5.24162 20.3354 7.74113 23.0086C10.2407 25.6819 10.6685 28.3728 10.5519 29.3177C9.60692 29.4344 6.916 29.0065 4.24277 26.507Z",
  fill: "#28BCA1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8194 17.3127C29.1462 14.8131 28.8358 12.037 28.9484 10.9432C30.0421 10.8306 32.8183 11.1411 35.3178 13.8143C37.8173 16.4875 38.2452 19.1785 38.1285 20.1234C37.1836 20.24 34.4927 19.8122 31.8194 17.3127Z",
  fill: "#28BCA1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6273 8.12248C19.9541 5.62296 19.6436 2.84679 19.7562 1.75305C20.85 1.64046 23.6261 1.95088 26.1257 4.62411C28.6252 7.29734 29.053 9.98827 28.9364 10.9332C27.9914 11.0498 25.3005 10.622 22.6273 8.12248Z",
  fill: "#28BCA1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7594 4.6229C34.2589 1.94967 37.035 1.63924 38.1288 1.75183C38.2414 2.84557 37.931 5.62174 35.2577 8.12126C32.5845 10.6208 29.8936 11.0486 28.9486 10.932C28.832 9.98705 29.2598 7.29612 31.7594 4.6229Z",
  fill: "#1DA48B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3748 23.0073C15.8744 20.3341 18.6505 20.0236 19.7443 20.1362C19.8569 21.23 19.5464 24.0061 16.8732 26.5057C14.2 29.0052 11.509 29.433 10.5641 29.3164C10.4475 28.3714 10.8753 25.6805 13.3748 23.0073Z",
  fill: "#1DA48B"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5672 13.8159C25.0667 11.1427 27.8429 10.8322 28.9366 10.9448C29.0492 12.0386 28.7388 14.8147 26.0656 17.3143C23.3924 19.8138 20.7014 20.2416 19.7565 20.125C19.6399 19.18 20.0677 16.4891 22.5672 13.8159Z",
  fill: "#1DA48B"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M4.18245 32.1987C6.68197 29.5255 9.45814 29.215 10.5519 29.3276C10.6645 30.4214 10.354 33.1976 7.68082 35.6971C5.00759 38.1966 2.31667 38.6244 1.37171 38.5078C1.2551 37.5629 1.68294 34.8719 4.18245 32.1987Z",
  fill: "#1DA48B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M4.24228 8.12223C1.56905 5.62272 1.25863 2.84655 1.37122 1.75281C2.46496 1.64021 5.24113 1.95064 7.74065 4.62387C10.2402 7.2971 10.668 9.98802 10.5514 10.933C9.60643 11.0496 6.91551 10.6218 4.24228 8.12223Z",
  fill: "#28BCA1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6268 26.5069C19.9536 24.0074 19.6431 21.2312 19.7557 20.1374C20.8495 20.0249 23.6257 20.3353 26.1252 23.0085C28.6247 25.6817 29.0525 28.3727 28.9359 29.3176C27.991 29.4342 25.3 29.0064 22.6268 26.5069Z",
  fill: "#28BCA1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4344 17.3136C10.7612 14.8141 10.4508 12.038 10.5634 10.9442C11.6571 10.8316 14.4333 11.142 16.9328 13.8153C19.4323 16.4885 19.8601 19.1794 19.7435 20.1244C18.7986 20.241 16.1076 19.8132 13.4344 17.3136Z",
  fill: "#28BCA1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8192 35.6983C29.146 33.1988 28.8355 30.4226 28.9481 29.3289C30.0419 29.2163 32.818 29.5267 35.3176 32.1999C37.8171 34.8731 38.2449 37.5641 38.1283 38.509C37.1833 38.6256 34.4924 38.1978 31.8192 35.6983Z",
  fill: "#28BCA1"
});

function SvgTileGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileGreen);
export default __webpack_public_path__ + "static/media/tile-green.3b1d90ef.svg";
export { ForwardRef as ReactComponent };